import {
    CLEAR_NOTIFICATION,
    DECREMENT_SYNC_QUEUE,
    INCREMENT_SYNC_QUEUE,
    PUSH_NOTIFICATION,
    UPDATE_DISPLAY_SETTINGS,
    UPDATE_GAMMA_CASE_IDX,
    UPDATE_GAMMA_FOLDER,
    UPDATE_GAMMA_STATE,
    UPDATE_IMAGE_LOAD_PROGRESS,
    UPDATE_LAST_IMAGE_RENDER_TIME,
    UPDATE_LAST_MAP_COUNT, UPDATE_MAGIC_TOOL_DATA_RETRIEVAL,
    UPDATE_TAWK_BOT,
} from '../redux_constants/gamma.state.const';
import {TileViewerConstants} from "../utils/const";

const InitialState = {
    notifications: [],
    activeMapId: null,
    activeAnnoDrawer: null,
    selectedDrawTool: null,
    selectedDrawColor: "#7CFC00",
    selectedAnnoWidth: 2,
    sync: false,
    syncId: -1,
    syncQueue: 0,
    lastMapCount: 0,
    scale: 1,
    tawkBot: null,
    topApp: false,
    bottomApp: false,
    tileMapEnable: false,
    bloodMapEnable: false,
    scannerData: {},
    selectedTileColor: TileViewerConstants.DEFAULT_COLOR,
    selectedTileSize: '16',
    rescanThreshValue1: 0.6,
    rescanThreshValue2: 0.9,
    displayedMapId: null, //use to display a different map on viewer without temporarily losing states
    imageLoadProgress: 101,
    defaultStainSettings: {},
    folder: {},
    caseIdx: -1,
    lastImageRenderTime: new Date().getTime(),
    magicToolDataRetrievalOngoing: false,
    // OSD feature-registry keys that switched this session to OpenLayers (see openseadragon/viewerSelection.js)
    osdFallbackFeatures: [],
    // Draw tool id (DrawInteractionOSD.TOOL_IDS) active on OSD maps; OL draw tools keep their own state
    activeDrawTool: null,
}

export const gammaStateReducer = (state = InitialState, action) => {
    switch (action.type) {

        case UPDATE_GAMMA_STATE:
            return {
                ...state,
                ...action.state,
            }

        case INCREMENT_SYNC_QUEUE:
            return {
                ...state,
                syncQueue: state.syncQueue + 1,
            }
        
        case DECREMENT_SYNC_QUEUE:
            return {
                ...state,
                syncQueue: state.syncQueue - 1,
            }

        case PUSH_NOTIFICATION:
            return {
                ...state,
                notifications: [
                    action.notification,
                    ...state.notifications.filter(notification => notification.props.id !== action.notification.props.id),
                ],
            }

        case CLEAR_NOTIFICATION:
            return {
                ...state,
                notifications: [...state.notifications.filter(notification => notification.props.id !== action.id)],
            }

        case UPDATE_LAST_MAP_COUNT:
            return {
                ...state,
                lastMapCount: state.lastMapCount + 1,
            }

        case UPDATE_TAWK_BOT:
            return {
                ...state,
                tawkBot: action.instance,
            }

        case UPDATE_DISPLAY_SETTINGS:
            return {
                ...state,
                displaySettings: {...state.displaySettings, ...action.displaySettings}
            }

        case UPDATE_IMAGE_LOAD_PROGRESS:
            return {
                ...state,
                imageLoadProgress: action.instance
            }

        case UPDATE_LAST_IMAGE_RENDER_TIME:
            return {
                ...state,
                lastImageRenderTime: action.instance
            }

        case UPDATE_GAMMA_FOLDER:
            return {
                ...state,
                folder: action.folder,
            }

        case UPDATE_GAMMA_CASE_IDX:
            return {
                ...state,
                caseIdx: action.caseIdx,
            }

        case UPDATE_MAGIC_TOOL_DATA_RETRIEVAL:
            return {
                ...state,
                magicToolDataRetrievalOngoing: action.instance
            }

        default:
            return state;
    }
}
